<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#5995B6" fill-rule="nonzero">
        <g>
          <path
            d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-4.243 0-8.313-1.686-11.314-4.686C1.686 24.314 0 20.244 0 16 0 7.163 7.163 0 16 0zm-3.817 7.98s-1.862.092-2.557.46c-.455.254-.58 1.099.073 1.15 2.953.443 5.628 1.915 7.373 3.922.02 1.632-.176 3.667-1.255 5.13 1.372-.019 2.34-.704 3.17-1.46.562 3.825-1.418 6.741-3.786 8.422-1.038-1.522-1.95-1.743-3.587-1.896-.681-.064-.757-.207-.441.53.703 1.702 1.492 2.51 2.781 2.514-.757 1.086-.68 1.802-.386 3.013.158.652.04.835.646.3 1.255-1.035 1.796-1.68 1.558-3.39 5.293-.57 9.084-4.15 8.826-10.675.851.055 1.33-.074 2.823.582.409.189.823.61.374-.31-.826-1.748-3.134-2.851-4.05-4.34-1.31-2.045-2.84-4.375-4.843-5.579-.668-.401-1.389-.679-2.171-.777-1.701-.213-3.55.19-4.548 2.404z"
            transform="translate(-565 -272) translate(280 248) translate(285 24)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'MySQLLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
